import { HiringPeopleIllustration } from '@restworld/utils-common';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface BannerProps {
  title: string;
  description: string;
}

export function Banner({ title, description }: BannerProps) {
  return (
    <div className="p-4 bg-white rounded-[15px] border border-gray-200 justify-start items-start gap-2.5 inline-flex">
      <div className="grow shrink basis-0 justify-start items-center gap-2 flex">
        <div className="grow shrink basis-0 flex-col justify-start items-start gap-2 inline-flex">
          <div className="self-stretch text-gray-900 text-sm font-semibold leading-[21px]">{title}</div>
          <div className="self-stretch text-gray-600 text-sm font-normal leading-[21px]">{description}</div>
        </div>
        <HiringPeopleIllustration
          {...{
            width: '95px',
            height: '95px',
          }}
        />
      </div>
    </div>
  );
}

export default Banner;
